module.exports = __webpack_public_path__ + "static/media/Lake_Bled_June_2019_Sunrise_long.f24f5bb5.mp4";